
(function(){
  var BUY_PRODUCTS = [15559451803721];
  var GIFT_VARIANT = 55748222484553;
  var TIERS = [[2, 2]]; // [[buy_qty, get_qty], ...] 由大到小
  var POOL = null;   // null 或 {ids:[商品id], min_cents:N, code:"免運碼"}
  var MARK = "ghost_chicken_buy2get2_202608";
  if (Date.now() < Date.parse("2026-08-07T00:00:00Z") || Date.now() > Date.parse("2026-08-23T15:59:59Z")) return;
  var busy = false;
  function desired(q){ for (var i=0;i<TIERS.length;i++){ if(q>=TIERS[i][0]) return TIERS[i][1]; } return 0; }
  function swapSection(html, sel){ var doc=new DOMParser().parseFromString(html,"text/html");
    var s=doc.querySelector(sel), d=document.querySelector(sel); if(s&&d) d.innerHTML=s.innerHTML; }
  function refresh(){
    if (location.pathname.replace(/\/$/,"")==="/cart"){ location.reload(); return Promise.resolve(); }
    return fetch("/?sections=cart-drawer,cart-icon-bubble").then(function(r){return r.json();}).then(function(s){
      if(s["cart-drawer"]) swapSection(s["cart-drawer"], "#CartDrawer");
      if(s["cart-icon-bubble"]){ var d=document.getElementById("cart-icon-bubble");
        if(d){ var doc=new DOMParser().parseFromString(s["cart-icon-bubble"],"text/html"); d.innerHTML=doc.body.innerHTML; } }
    }).catch(function(){});
  }
  function sync(){
    if (busy) return; busy = true;
    fetch("/cart.js").then(function(r){return r.json();}).then(function(cart){
      var q=0, line=null, pool=0;
      cart.items.forEach(function(i){
        if (BUY_PRODUCTS.indexOf(i.product_id)>=0) q+=i.quantity;
        if (i.variant_id===GIFT_VARIANT && i.properties && i.properties._auto_gift===MARK) line=i;
        if (POOL && POOL.ids.indexOf(i.product_id)>=0) pool+=i.final_line_price;
      });
      if (POOL && pool>=POOL.min_cents && !sessionStorage.getItem("fs_"+POOL.code)){
        sessionStorage.setItem("fs_"+POOL.code, "1");
        fetch("/discount/"+POOL.code).catch(function(){});
      }
      var want=desired(q), have=line?line.quantity:0;
      if (want===have) return null;
      if (!line && want>0)
        return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},
          body:JSON.stringify({items:[{id:GIFT_VARIANT,quantity:want,properties:{_auto_gift:MARK}}]})}).then(refresh);
      if (line)
        return fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},
          body:JSON.stringify({id:line.key,quantity:want})}).then(refresh);
    }).catch(function(){});
    setTimeout(function(){ busy=false; }, 900);
  }
  var of = window.fetch;
  window.fetch = function(){ var a=arguments, u=typeof a[0]==="string"?a[0]:(a[0]&&a[0].url)||"";
    var p=of.apply(this,a);
    if(!busy && /\/cart\/(add|change|update|clear)/.test(u)) p.then(function(){ setTimeout(sync,400); });
    return p; };
  var ox = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m,u){
    try{ if(!busy && /\/cart\/(add|change|update|clear)/.test(u)) this.addEventListener("load",function(){ setTimeout(sync,400); }); }catch(e){}
    return ox.apply(this,arguments); };
  if (document.readyState==="loading") document.addEventListener("DOMContentLoaded",function(){ setTimeout(sync,600); });
  else setTimeout(sync,600);
})();
